export default {"src":"/_next/static/media/warning-circle.3b98548e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};